import React, {Component} from 'react';
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Card, CardHeader, Row, Col} from 'reactstrap';
import {Dropdown, Rating, Label} from "semantic-ui-react";
import * as common from "../../../../../../const/Common/CommonFunc";
import axios_eventtag from "../../../../../../axios/axios_eventtag";
import apiConfig from "../../../../../../axios/axios_api_services";
import Cookies from "js-cookie";
import {connect} from "react-redux";
import * as actionCreator from "../../../../../../store/Action";
import './Style.scss';
import Download from "../../../../../../components/Button/DownloadbleButton/index";
import {Button as SementicBtn} from "semantic-ui-react";
import {Tooltip} from "antd";
import ParticipantModal from './modal/participantsModal';
import ParticipantRateModal from './modal/participantRatingModal';

class sessionFeedback extends Component {
  state = {

    questions: [],
    event_list: [],
    eventSubEvents: [],
    subEventSessions: [],

    eventId: '',
    subEventId: '',
    feedbacks: [],
    subeventfeedbacks: [],
    isFeedbackQuestion: false,
    isSubEventFeedback: false,
    participant_id: '',
    feedback_id: '',
    participantFeedbacks: [],
    isCardDisplay: true,
    selectObj: '',
    subeventparticipantFeedbacks: [],


    rateFeedBackToParticipants: [],
    participnatFeedBackToRate: []

  };

  getEvents = (status) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.CORPORATE_EVENTS({corporateId: corperateId}), {headers: headers})
      .then(async response => {
        this.props.spinnerHandler(false);

        if (response.data.success) {
          this.setState({
            event_list: response.data.eventList,
            eventSubEvents: [],
          });
          // if(status === "ON_LOAD"){
          //   let firstEventId = response.data.eventList.length !== 0 ? response.data.eventList[0].event_id : '';
          //   this.setState({
          //     eventId: firstEventId
          //   });
          //   // this.getSubEvents(null, {value: firstEventId})
          // }
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getEvents(status);
        } else {
          this.props.spinnerHandler(false)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  dropdownOnchange = name => (e, {value}) => {
    this.setState({
      // subEventId: name === 'subEventId' ? this.state.subEventId : '',
      feedbacks: [],
      [name]: value,
    });

    switch (name) {
      case "eventId":
        this.getSubEvents(e, {value});
        break;
      case "subEventId":
        this.setSubEventId(e, {value});
        this.callData();
        break;
      default:
        break;
    }
  };

  callData = () => {
    this.getAllFeedbacks();
    this.getSubEventFeedback();
  }

  setSubEventId = (e, {value}) => {
    this.setState({
      subEventId: value
    })

  }

  getAllFeedbacks = () => {
    if(this.state.subEventId !== 0 & this.state.subEventId !== '') {
      this.getAllFeedbacks_();
    }
  }

  getAllFeedbacks_ = () => {
    let sub_id = this.state.subEventId;

    this.setState({
      isCardDisplay: true
    })
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios_eventtag.get(apiConfig.GET_FEEDBACK_QUESTION_RATES({sub_event_id: sub_id, corporateId: corporateId}), {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {
          let subEventFeedbackList = response.data.content.subEventFeedbackList;
          this.setState({
            feedbacks : (subEventFeedbackList==null || subEventFeedbackList == undefined)?[]:subEventFeedbackList,
            // participantFeedbacks : response.data.content.subeventFeedbackList.participant_feedback_list
          });
        } else {
          this.setState({
            feedbacks: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllFeedbacks();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  getSubEventFeedback = () => {
    if(this.state.subEventId !== 0 & this.state.subEventId !== '') {
      this.getSubEventFeedback_();
    }
  }

  getSubEventFeedback_ = () => {
    let sub_id =  this.state.subEventId;
    this.setState({
      isCardDisplay: false
    })
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios_eventtag.get(apiConfig.GET_OVERALL_SUBEVENT_FEEDBACKS({sub_event_id: sub_id, corporateId: corporateId}), {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {
          let participantFeedbackList = response.data.content.participant_feedback_list;
          this.setState({
            subeventfeedbacks : (participantFeedbackList==null || response.data.content.participant_feedback_list==undefined)?[]:participantFeedbackList,
          });
        }
         else {
          this.setState({
            subeventfeedbacks: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getSubEventFeedback(sub_id);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  getSubEvents = (e, {value}) => {
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios_eventtag.get(apiConfig.GET_ALL_SUB_EVENT({event_id: value, corporateId: corporateId}), {headers: headers})
      .then(response => {

        this.props.spinnerHandler(false);
        if (response.data.success) {
          this.setState({
            eventSubEvents: response.data.subEventList
          });
        } else {
          this.setState({
            eventSubEvents: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getSubEvents(e, {value});
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  openFeedbackModal = (value) => {
    this.setState({
      isFeedbackQuestion: true,
      feedback_id: value.feedback_id,
      rateFeedBackToParticipants: value.participant_feedback_list !== null? value.participant_feedback_list : []
    })
  }

  openSubeventFeedbackModal = (value) => {
    this.setState({
      isSubEventFeedback: true,
      participant_id: value.participant_id,
      participnatFeedBackToRate: value.rates
    })
  };

  setSubEventFeedback = (sub_id) => {
    this.setState({
      isCardDisplay: true,
      selectObj: sub_id
    })
  }

  componentDidMount() {
    this.getEvents("ON_LOAD_");
  }


  closeParticipantModal = () => {
    this.setState({
      isFeedbackQuestion: false,
      rateFeedBackToParticipants:[]
    });
  };

  closeParticipantRateModal = () => {
    this.setState({
      isSubEventFeedback: false,
      participnatFeedBackToRate: []
    })
  };

  render() {



    let elist = [];
    if (this.state.event_list !== null) {
      this.state.event_list.map((value, index) => {
        elist.push({
          text: value.event_name,
          value: value.event_id,
          key: value.event_id
        })
      })
    }

    let subEventList = [];

    if (this.state.eventSubEvents.length !== 0) {
      this.state.eventSubEvents.map((value, index) => {
        subEventList.push({
          text: value.name,
          value: value.sub_event_id,
          key: value.sub_event_id
        });
      });
    }

    let columns = this.props.table_data.columns;
    let rows = [];
    let feedback_rows = [];

    let p_feedback = [];

    // --------------------------------------------------------------------------------------------------------------

    if(this.state.rateFeedBackToParticipants !== null) {

      this.state.rateFeedBackToParticipants.map((value, index) => {
        let obj = {
            name: value.name,
            email: value.email,
            rate:
              <div style={{paddingTop: '5px'}}>
                <Rating disabled={true} maxRating={5} defaultRating={value.rate} icon='star' size='huge'/>,
              </div>
        };
        feedback_rows.push(obj)
      })
    }

    if(this.state.participnatFeedBackToRate !== null) {
      this.state.participnatFeedBackToRate.map((value, index) => {
        let obj = {
          feedback: value.feedback,
          rate:
            <div style={{paddingTop: '5px'}}>
              <Rating disabled={true} maxRating={5} defaultRating={value.rate} icon='star' size='huge'/>,
            </div>
        }
        p_feedback.push(obj);
      });
    }

    // --------------------------------------------------------------------------------------------------------------

    if (this.state.feedbacks.length !== 0) {
      this.state.feedbacks.map((value, index) => {
        rows.push({
          feedback: value.feedback,
          rating:
          <div style={{paddingTop: '5px'}}>
            <Rating disabled={true} maxRating={5} defaultRating={value.rate} icon='star' size='huge'/>,
          </div>,
          action: <SementicBtn circular icon='eye' onClick={() => this.openFeedbackModal(value)}/>
        })
      })
    }

    let s_rows = [];
    if (this.state.subeventfeedbacks.length !== 0) {
      this.state.subeventfeedbacks.map((value, index) => {
        s_rows.push({
          name: value.name,
          feedback: (value.comment !== null & value.comment !== "") ? value.comment : "-",
          action: <SementicBtn circular icon='eye' onClick={() => this.openSubeventFeedbackModal(value)}/>
        })
      })
    }

    let f_cols = this.props.feedback_question_table.columns;
    let subevent_feedback_cols = this.props.feedback_question_table_2.columns;
    let s_cols = this.props.tabel_data_subeventF.columns;
    // let sub_id = this.state.subEventId;


    return (
      <div className="event-session-feedback">
        {
          this.state.isFeedbackQuestion ? <ParticipantModal columns={f_cols} rows={feedback_rows} closeModal={()=>
            this.closeParticipantModal()}/> : ""
        }

        {
          this.state.isSubEventFeedback ? <ParticipantRateModal columns={subevent_feedback_cols} rows={p_feedback}
                                                                closeModal={()=> this.closeParticipantRateModal()}/>
            : ""
        }
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card className="card1">
              <CardHeader>
                Filter Events
              </CardHeader>
              <Col lg={12}>
                <Row className={"search-event-row"}>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Event'
                      fluid
                      selection search
                      options={elist}
                      value={this.state.eventId}
                      onChange={this.dropdownOnchange("eventId")}
                    />
                  </Col>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Sub Event'
                      fluid
                      selection search
                      options={subEventList}
                      value={this.state.subEventId}
                      onChange={this.dropdownOnchange("subEventId")}
                    />
                  </Col>
                </Row>
              </Col>
            </Card>
          </Col>
        </Row>
        <Row>
          <Tooltip placement="topLeft" title="Feedback Question Rate">
            <Label
              onClick={this.getAllFeedbacks}
              color='grey' horizontal
              style={{cursor: 'pointer', marginLeft: '15px'}}
            >
              {"Feedback Question Ratings"}
            </Label>
          </Tooltip>
          <Tooltip placement="topLeft" title="Overall Subevent Feedbacks">
            <Label
              onClick={this.getSubEventFeedback}
              color='blue' horizontal
              style={{cursor: 'pointer'}}
            >
              {"Overall Subevent Feedbacks"}
            </Label>
          </Tooltip>
        </Row>
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card className="card1">
              <CardHeader>
                Feedback Questions and Ratings
                {/*<Download data={rows} filename={"subeventfeedbacks.csv"}/>*/}
              </CardHeader>
              <Col lg={"12"}>
                <Row className={"search-event-row"}>
                  <Col lg={"12"} md={"12"}>
                    <MDBDataTable
                      className={ !this.state.isCardDisplay? "tbl-event-feedback-questions-and-ratings" : "" }
                      striped
                      searching={true}
                      displayEntries={true}
                      bordered
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      hover
                      // className={"table thead th"}
                      data={{
                        rows: this.state.isCardDisplay ? rows : s_rows,
                        columns: this.state.isCardDisplay ? columns : s_cols
                      }}
                    />
                  </Col>
                </Row>
              </Col>

            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  table_data: state.feedbackReducer.subEvent_feedback_table,
  feedback_question_table: state.feedbackReducer.feedback_table_1,
  feedback_questions: state.feedbackReducer.feedback_Question_Array,
  feedback_question_table_2: state.feedbackReducer.feedback_table_2,
  tabel_data_subeventF: state.feedbackReducer.subEvent_participant_feedback_table
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // all available cards
    // receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(sessionFeedback);
